(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("slider", [], factory);
	else if(typeof exports === 'object')
		exports["slider"] = factory();
	else
		root["slider"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 